import { useAppSelector, useTranslate } from '@common/hooks'
import ModalWrapper from '@common/modals/ModalWrapper'
import { useFormContext } from 'react-hook-form'

import ModalContent from './ModalContent'


interface IProps {
  confirmationSlot: number | null,
  onHide: () => void,
  onSubmit: () => Promise<unknown>,
  showConfirmationModal: boolean,
}

export default function ConfirmationModal({
  confirmationSlot,
  onHide,
  onSubmit,
  showConfirmationModal,
}: IProps): JSX.Element | null {
  const { formState: { isSubmitting } } = useFormContext()
  const { translate, interpolate } = useTranslate()
  const application = useAppSelector(store => store.application.data)
  const oldApplication = useAppSelector(store => {
    const apps = store.userSlots.data?.items
    return apps && confirmationSlot ? apps.find(app => app.slot === confirmationSlot) : undefined
  })
  if(!application || !confirmationSlot) {
    return null
  }
  return <ModalWrapper
    show={showConfirmationModal}
    component={ModalContent}
    newApp={application.name}
    oldApp={oldApplication?.name || ''}
    slotId={confirmationSlot}
    title={interpolate(translate('%s installation'), [application.name])}
    isSubmitting={isSubmitting}
    onHide={() => {
      onHide()
    }}
    onClose={() => {
      if(!confirmationSlot) {
        return onHide()
      }
      void onSubmit()
        .then(() => onHide())
    }}
  />
}
